import React from 'react';
import CtaButton from 'components/cta-button/cta-button';

const CtaButtonBlock = ({
  backgroundColor,
  url,
  text,
  openInNewTab = false,
}) => (
  <div className="cta-button-block">
    <div className="cta-button-block__container">
      <CtaButton
        className="cta-button-block__button"
        backgroundColor={backgroundColor}
        url={url}
        text={text}
        openInNewTab={openInNewTab}
      />
    </div>
  </div>
);

CtaButtonBlock.propTypes = CtaButton.propTypes;

export default CtaButtonBlock;
